import { render, staticRenderFns } from "./datas.vue?vue&type=template&id=77245fa6&"
import script from "./datas.vue?vue&type=script&lang=js&"
export * from "./datas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77245fa6')) {
      api.createRecord('77245fa6', component.options)
    } else {
      api.reload('77245fa6', component.options)
    }
    module.hot.accept("./datas.vue?vue&type=template&id=77245fa6&", function () {
      api.rerender('77245fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/authority/components/datas.vue"
export default component.exports